import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Task, TaskStatus } from '@contracts/interfaces/task.interface';
import { ConnectionService } from './connection.service';
import { TaskDialogComponent } from '../dialogs/task-dialog/task.dialog';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class TaskService {


  constructor(private http: HttpClient,
      private connectionService: ConnectionService,
      private dialog: MatDialog) {}
  
    
    find(query: any = {}) {
      return this.http.post(this.connectionService.address + "/task-service/find", { query });
    }

    get(id: number) {
      return this.http.post(this.connectionService.address + "/task-service/get", { id });
    }
  
    create(task: Task) {
      return this.http.post(this.connectionService.address + "/task-service/create", { task });
    }

    update(task: Task) {
      return this.http.post(this.connectionService.address + "/task-service/update", { task });
    }
  
    delete(task: Task) {
      return this.http.post(this.connectionService.address + "/task-service/delete", { task });
    }

    getInfo() {
      return this.http.post(this.connectionService.address + "/task-service/get-info", { });
    }

    getActive() {
      const query = {
        status: {
          $nin: [TaskStatus.Completed, TaskStatus.Queued, TaskStatus.ToBePickedUp]
        }
      };
      return this.http.post<any[]>(this.connectionService.address + "/task-service/find", { query });
    }

    openTaskDialog(task: Task, list: number[], currentIndex: number, callback: any) {

      let dialog = this.dialog.open(TaskDialogComponent, {
        width: '1200px',
        height: '100vh',
        data: {
          task,
          list,
          currentIndex
        }
      });
  
      dialog.afterClosed().subscribe((r: any) => {
        callback(r);
      })
    }

}
